






























import { Component, Mixins, Prop, Vue } from "vue-property-decorator";
import VAccordion from "@/components/VAccordion.vue";
import ModelParserMixin from "@/mixins/ModelParser";
import VSelect from "@/components/VSelect.vue";
import { currentScoutingStore } from "@/store/typed";
import ScoutingAreaItem from "@/components/ScoutingArea/Item.vue";
import ScoutingGroupItem from "@/components/Analysis/ScoutingGroupItem.vue";
import ScoutingGroup from "@/models/ScoutingGroup";
import { AnalysisState } from "@/models/Scouting";
import GenericCable from "@/cables/GenericCable";
import ScoutingGroupMixin from "@/mixins/http/ScoutingGroupMixin";

@Component({
  components: {
    VAccordion,
    ScoutingAreaItem,
    VSelect,
    ScoutingGroupItem,
  },
})
export default class GroupCollapsableList extends Mixins(ScoutingGroupMixin) {
  @Prop({ default: false }) readonly isOpened!: boolean;

  cable: GenericCable | null = null;

  async mounted() {
    this.startCable();
    const analysis = currentScoutingStore.scoutingAnalysis;

    if (!analysis) {
      return;
    }

    const groups = await this.getScoutingGroups(analysis.scouting!.id);
    analysis.scouting.scoutingGroups = groups;
    currentScoutingStore.setScoutingAnalysis(analysis);
  }

  startCable() {
    this.cable = new GenericCable("AnalysesChannel");
    this.cable.onResponse = this.onResponse;
    this.cable.open({
      id: currentScoutingStore.scoutingAnalysis!.scouting!.id,
    });
  }

  onResponse(data: any) {
    if (data.status === 200) {
      const analysis = currentScoutingStore.scoutingAnalysis;

      if (!analysis) {
        return;
      }

      const groups = this.scoutingGroups;
      const index = groups.findIndex((e) => e.id === data.message.id)!;

      groups[index].status = data.message.status;
      groups[index].metadata = data.message.metadata;
      analysis.scouting.scoutingGroups = groups;

      currentScoutingStore.setScoutingAnalysis(analysis);
    }
  }

  destroyed() {
    this.cable?.close();
  }

  get scoutingGroups() {
    return currentScoutingStore.scoutingAnalysis?.scouting.scoutingGroups || [];
  }

  onStatusChanged(closed: boolean) {
    this.$emit("status", closed);
  }

  get groupsCount() {
    return this.scoutingGroups.length;
  }

  onNewGroupClick() {
    this.$router.push({ name: "create_group" });
  }

  get companyId() {
    return this.$route.params.id;
  }

  get analysisId() {
    return this.$route.params.analysisId;
  }

  onItemSelectedForEdit(item: ScoutingGroup) {
    this.$router.push({
      name: "edit_group",
      params: {
        groupId: item.id,
        analysisId: this.analysisId,
        id: this.companyId,
      },
    });
  }

  onItemSelectedForDelete(item: ScoutingGroup) {
    this.$parent.$emit("delete-group", item);
  }

  async onItemSelected(item: ScoutingGroup) {
    await currentScoutingStore.clearSelection();
    await currentScoutingStore.changeScoutingAnalysisState(AnalysisState.Group);
    await currentScoutingStore.changeScoutingAnalysisCurrentGroup(item);
  }
}
